import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { useSubscription } from '@/hooks/useSubscription';

export function TrialBanner() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { isTrial, trialDaysRemaining, subscription } = useSubscription();

  // Hide on subscription settings page (it has its own trial section)
  if (location.pathname === '/settings/subscription') return null;

  // Only show for active trials
  if (!isTrial || subscription?.status !== 'trialing') return null;

  const isUrgent = trialDaysRemaining <= 3;
  const isLastDay = trialDaysRemaining <= 1;

  const bannerText = isLastDay
    ? t('trial.bannerLastDay')
    : isUrgent
      ? t('trial.bannerUrgent', { days: trialDaysRemaining })
      : t('trial.banner', { days: trialDaysRemaining });

  return (
    <div
      className={`flex items-center justify-between px-3 h-8 text-xs ${
        isUrgent
          ? 'bg-gradient-to-r from-red-500/10 to-orange-500/10 border-b border-red-300/40'
          : 'bg-gradient-to-r from-[#B8860B]/10 to-[#D4AF37]/10 border-b border-[#D4AF37]/30'
      }`}
    >
      <div className="flex items-center gap-1.5">
        <span className="text-sm">&#9201;</span>
        <span className={`font-medium ${isUrgent ? 'text-red-700' : 'text-[#8B6914]'}`}>
          {bannerText}
        </span>
      </div>
      <button
        onClick={() => navigate('/settings/subscription')}
        className={`flex items-center gap-1 font-semibold ${
          isUrgent
            ? 'text-red-700 hover:text-red-800'
            : 'text-[#B8860B] hover:text-[#8B6914]'
        }`}
      >
        {t('trial.viewPlans')} <ArrowRight className="h-3 w-3" />
      </button>
    </div>
  );
}
